module.exports = __webpack_public_path__ + "static/media/esign_kyc_fail.33050523.svg";